
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AuthMode, AuthTab } from './types';

export const useAuthFormState = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);
  const [tab, setTab] = useState<AuthTab>('login');
  const [mode, setMode] = useState<AuthMode>('login');
  
  const location = useLocation();

  // Reset form states
  const resetForm = () => {
    setEmail('');
    setPassword('');
    setLoading(false);
    setGoogleLoading(false);
  };

  const resetPassword = () => {
    setPassword('');
  };

  const resetPasswordVisibility = () => {
    setShowPassword(false);
  };

  // Set initial mode based on URL parameters or current path
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const modeParam = params.get('mode');
    
    // Check if we're on the reset-password page
    if (location.pathname.includes('/auth/reset-password')) {
      setMode('resetPassword');
    } else if (modeParam) {
      switch (modeParam) {
        case 'forgotPassword':
          setMode('forgotPassword');
          break;
        case 'resetPassword':
          setMode('resetPassword');
          break;
        case 'signup':
          setMode('signup');
          setTab('signup');
          break;
        case 'login':
        default:
          setMode('login');
          setTab('login');
      }
    }
  }, [location.search, location.pathname]);

  return {
    email,
    setEmail,
    password,
    setPassword,
    showPassword,
    setShowPassword,
    loading,
    setLoading,
    googleLoading,
    setGoogleLoading,
    tab,
    setTab,
    mode,
    setMode,
    resetForm,
    resetPassword,
    resetPasswordVisibility
  };
};

export default useAuthFormState;
